function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.3001 9.30001C15.4927 9.15558 15.7309 9.08546 15.971 9.10252C16.2111 9.11959 16.437 9.22269 16.6072 9.3929C16.7774 9.56311 16.8805 9.78901 16.8976 10.0291C16.9146 10.2692 16.8445 10.5074 16.7001 10.7L12.7001 14.7C12.5132 14.8832 12.2619 14.9859 12.0001 14.9859C11.7383 14.9859 11.487 14.8832 11.3001 14.7L7.3001 10.7C7.15567 10.5074 7.08555 10.2692 7.10261 10.0291C7.11968 9.78901 7.22278 9.56311 7.39299 9.3929C7.5632 9.22269 7.7891 9.11959 8.02921 9.10252C8.26932 9.08546 8.50753 9.15558 8.7001 9.30001L12.0001 12.59L15.3001 9.29001V9.30001Z"
});

var SvgChevronDown = function SvgChevronDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChevronDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-down.538927d0.svg";
export { ForwardRef as ReactComponent };